/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-01-23T10:23:58-08:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-13T11:27:46-07:00
 */

import { StyleSheet } from "aphrodite";

/* UI component constants
 *
 *
 */
export const dimensions = {

  SCREEN_MIN_XXS: "@media (min-width: 320px)",
  SCREEN_MAX_XXS: "@media (max-width: 320px)",

  SCREEN_MIN_XS: "@media (min-width: 480px)",
  SCREEN_MAX_XS: "@media (max-width: 479px)",

  SCREEN_MIN_SM: "@media (min-width: 640px)",
  SCREEN_MAX_SM: "@media (max-width: 639px)",

  SCREEN_MIN_MD: "@media (min-width: 769px)",
  SCREEN_MAX_MD: "@media (max-width: 768px)",

  SCREEN_MIN_LG: "@media (min-width: 944px)",
  SCREEN_MAX_LG: "@media (max-width: 944px)",

  SCREEN_MIN_XL: "@media (min-width: 944px)",
  SCREEN_MAX_XL: "@media (max-width: 944px)"
};

export const textColor = {
  // Grey colors. Use for normal body and Title text.
  LIGHTER: { color: "rgba(0,0,0,.4)" },
  NORMAL: { color: "rgba(0,0,0,.6)" },
  DARK: { color: "rgba(0,0,0,.6)" },
  DARKER: { color: "rgba(0,0,0,.8)" },
  DARKEST: { color: "rgba(0,0,0,.9)" },

  //Misc. Colors
  RED: { color: "rgb(204, 84, 84)" },

  //MT Retheme
  LIGHT_GRAY: {color: "#999999" },
  LIGHT_PURPLE: {color: "#DDD3F7"},
  PURPLE: { color: "#674DAA" },
  PURPLE_GRAY: {color: "#726C82"}
};

export const color = {
  GREY_1: "rgba(0, 0, 0, 0.033)",
  GREY_2: "rgba(0, 0, 0, 0.44)",
  GREY_3: "",
  GREY_LIGHTEST: "rgba(0,0,0,0.02)",
  PURPLE_GREY: "#726C82",

  //Brand colors
  BRAND_1: "#674DAA",
  BRAND_1_DARK: "#231035",

};

export const size = {
  SIZE_40X40: {
    height: "40px",
    width: "40px"
  },
  SIZE_60X60: {
    height: "60px",
    width: "60px"
  },
  SIZE_80X80: {
    height: "80px",
    width: "80px"
  },
  SIZE_90X90: {
    height: "90px",
    width: "90px"
  }
};

export const type = {
  XS: { fontSize: "12px" },
  SM: { fontSize: "14px" },
  MD: { fontSize: "16px" },
  LG: { fontSize: "18px" },
  XL: { fontSize: "22px" },

  //weights
  THIN: { fontWeight: "300" },
  NORMAL: { fontWeight: "400" },
  // MEDIUM: {fontWeight: '500'},
  BOLD: { fontWeight: "700" },

  title: {
    XS: { fontSize: "18px" },
    SM: { fontSize: "20px" },
    MD: { fontSize: "24px" },
    LG: { fontSize: "30px" },
    XL: { fontSize: "36px" }
  }
};

export const leading = {
  // Relative Units
  BASE: { lineHeight: "1.4" },
  TIGHT: { lineHeight: "1.2" },
  TIGHTER: { lineHeight: "1.1" },
  TIGHTEST: { lineHeight: "1" },
  LOOSE: { lineHeight: "1.6" },
  INHERIT: { lineHeight: "inherit" }

  // Add absolute units here.
};

export const spacing = {
  MARGIN_0: { margin: "0" },
  MARGIN_SM: { margin: "10px" },
  MARGIN_MD: { margin: "16px" },

  MARGIN_BOTTOM_XS: { marginBottom: "4px" },
  MARGIN_BOTTOM_SM: { marginBottom: "10px" },
  MARGIN_BOTTOM_MD: { marginBottom: "16px" },
  MARGIN_BOTTOM_LG: { marginBottom: "22px" },
  MARGIN_BOTTOM_XL: { marginBottom: "32px" },

  MARGIN_TOP_XS: { marginTop: "4px" },
  MARGIN_TOP_SM: { marginTop: "10px" },
  MARGIN_TOP_MD: { marginTop: "16px" },
  MARGIN_TOP_LG: { marginTop: "22px" },
  MARGIN_TOP_XL: { marginTop: "32px" },

  MARGIN_V_XS: { margin: "4px 0" },
  MARGIN_V_SM: { margin: "10px 0" },
  MARGIN_V_MD: { margin: "22px 0" },
  MARGIN_V_LG: { margin: "32px 0" },

  MARGIN_LEFT_XS: { marginLeft: "4px" },
  MARGIN_LEFT_SM: { marginLeft: "10px" },
  MARGIN_LEFT_MD: { marginLeft: "16px" },
  MARGIN_LEFT_LG: { marginLeft: "22px" },
  MARGIN_LEFT_XL: { marginLeft: "32px" },

  MARGIN_LEFT_NEG_XL: { marginLeft: "-32px" },

  MARGIN_RIGHT_XS: { marginRight: "4px" },
  MARGIN_RIGHT_SM: { marginRight: "10px" },
  MARGIN_RIGHT_MD: { marginRight: "16px" },
  MARGIN_RIGHT_LG: { marginRight: "22px" },
  MARGIN_RIGHT_XL: { marginRight: "32px" },

  MARGIN_H_MD: { margin: "0 22px" },
  MARGIN_H_LG: { margin: "0 32px" },

  MARGIN_RIGHT_SM_NEG: { marginRight: -10 },

  PADDING_0: { padding: "0" },
  PADDING_XS: { padding: "4px" },
  PADDING_SM: { padding: "10px" },
  PADDING_MD: { padding: "16px" },
  PADDING_LG: { padding: "22px" },

  // padding

  PADDING_H_SM: { padding: "0 10px" },
  PADDING_H_MD: { padding: "0 22px" },

  PADDING_BOTTOM_XS: { paddingBottom: "4px" },
  PADDING_BOTTOM_SM: { paddingBottom: "10px" },
  PADDING_BOTTOM_MD: { paddingBottom: "16px" },
  PADDING_BOTTOM_LG: { paddingBottom: "22px" },
  PADDING_BOTTOM_XL: { paddingBottom: "32px" },

  PADDING_TOP_XS: { paddingTop: "4px" },
  PADDING_TOP_SM: { paddingTop: "10px" },
  PADDING_TOP_MD: { paddingTop: "16px" },
  PADDING_TOP_LG: { paddingTop: "22px" },
  PADDING_TOP_XL: { paddingTop: "32px" },

  PADDING_V_XS: { padding: "4px 0" },
  PADDING_V_SM: { padding: "10px 0" },
  PADDING_V_MD: { padding: "22px 0" },
  PADDING_V_XL: { padding: "32px 0" },

  PADDING_LEFT_XS: { paddingLeft: "4px" },
  PADDING_LEFT_SM: { paddingLeft: "10px" },
  PADDING_LEFT_MD: { paddingLeft: "16px" },
  PADDING_LEFT_LG: { paddingLeft: "22px" },
  PADDING_LEFT_XL: { paddingLeft: "32px" },

  PADDING_RIGHT_XS: { paddingRight: "4px" },
  PADDING_RIGHT_SM: { paddingRight: "10px" },
  PADDING_RIGHT_MD: { paddingRight: "16px" },
  PADDING_RIGHT_LG: { paddingRight: "22px" },
  PADDING_RIGHT_XL: { paddingRight: "32px" }

  //spacing (Margin) utils
  //spacing (inter - Padding) utils
};

export const borders = {
  DEFAULT: "1px solid rgba(0,0,0,0.14)",
  DARKER: "1px solid rgba(0,0,0,0.15)",
  BRAND: "1px solid " + color.BRAND_1
};

export const box = {
  border: borders.DEFAULT,
  boxShadow: "0 1px 4px 0 rgba(0,0,0,.04)",
  borderRadius: "3px"
};

/**
 * FORM Components
 * Use these until we create common form Components
 */

export const textInput = {
  width: "100%",
  boxSizing: "border-box",
  padding: "0 15px",
  height: "38px",
  outline: "none",
  borderRadius: "3px",
  border: borders.DARKER,
  ...type.MD
};

export const comboBox = {
  appearance: "none",
  outline: "0",
  boxSizing: "border-box",
  background: "0 0",
  border: borders.DARKER,
  padding: "0 15px",
  height: "38px",
  outline: "none",
  borderRadius: "3px",
  ...type.SM
};

export const textArea = {};

export const truncate = {
  maxWidth: "100%",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};

export const link = StyleSheet.create({
  Link: {
    color: color.BRAND_1
  }
});



// WEBPACK FOOTER //
// ./src/style/index.js